const filter_categories = [
//     {
//       id: 1,
//       name: 'Project',
//       apiname: 'project',
//     },
//     {
//       id: 2,
//       name: 'Stage',
//       apiname: 'stage',
//     },
//     //   {
//     //   id: 3,
//     //   name: 'Group',
//     //   apiname: 'group',
//     // },
//     //   {
//     //   id:42,
//     //   name: 'Allocation',
//     //   apiname: 'allocation',
//     // },
//       {
//       id: 3,
//       name: 'Status',
//       apiname: 'status',
//     },
//   {
//       id: 4,
//       name: 'Type',
//       apiname: 'type',
//     },
//   // {
//   //     id: 7,
//   //     name: 'Lot',
//   //     apiname: 'lot',
//   //   },
//   {
//       id: 5,
//       name: 'Tranche',
//       apiname: 'tranche',
//     },
//   {
//       id: 6,
//       name: 'Milestone',
//       apiname: 'milestone',

//     }

      {
      id: 1,
      name: 'Tranche',
      apiname: 'tranche',
    },
    {
      id: 2,
      name: 'Project',
      apiname: 'project',
    },
    {
      id:3,
      name: 'Stage',
      apiname: 'stage',
    },
      {
      id: 4,
      name: 'Status',
      apiname: 'status',
    },
  {
      id: 5,
      name: 'Type',
      apiname: 'type',
    },

  {
      id: 6,
      name: 'Milestone',
      apiname: 'milestone',

    }

  ];

export default filter_categories
